import profile_img from '../../assets/images/pages/defaultImage.jpg';
import '../../assets/styles/pages.scss'
import { Link, useNavigate } from 'react-router-dom';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { GlobalContext, handleError } from '../../context/Provider';
import henceforthApi from '../../utils/henceforthApi';
import VerifyOtp from '../../components/modals/VerifyEmailOtp';
import authAction from '../../context/authAction';
import { toast } from 'react-toastify';
import { getImageSignedUrl } from '../../utils/signedUrl';
const Profile = () => {
    const { language_data, authState, authDispatch, loading, setLoading } = useContext(GlobalContext)
    const [openEmailVerification, setOpenEmailVerification] = React.useState(false)
    const [profileImageUrl, setProfileImageUrl] = useState<string>(profile_img)
    const [documentUrls, setDocumentUrls] = useState<{ [key: string]: { front?: string, back?: string } }>({})
    const navigate = useNavigate()
    const initialiseProfile = async (data: any) => {
        try {
            let apiRes = await henceforthApi.Auth.emailVerifyOtp({ otp: data, language: 'ENGLISH' })
            console.log('apiRes------', apiRes);
            authAction.initialiseProfile(apiRes.data)(authDispatch);
            setOpenEmailVerification(false)
        } catch (err) {
            handleError(err, 'active', authDispatch)
        }

    }
    const resendEmailOtp = async () => {
        if (loading) return
        setLoading(true)
        try {
            let items = {
                email: authState.email,
                language: "ENGLISH"
            }
            let apiRes = await henceforthApi.Auth.emailVerifySendOtp(items)
            // toast.success(apiRes.data)
            // setOpenEmailVerification(true)
            return apiRes.data
        } catch (error: any) {
            // if (error.response && error.response.body) {
            //     toast.error(error.response.body.error_description)
            // }
            handleError(error, 'active', authDispatch)
        } finally {
            setLoading(false)
        }
    }

    const OpenEmailVerification = async () => {
        await resendEmailOtp()
        setOpenEmailVerification(true)
    }


    const handleResubmitProfile = async () => {
        setLoading(true)
        try {
            const apiRes = await henceforthApi.Auth.resubmitProfile()

            // Update the auth state with the new profile data
            if (apiRes?.data) {
                authAction.initialiseProfile(apiRes.data)(authDispatch)
                toast.success('Profile resubmitted successfully! Your account is now under review.')
            }
        } catch (error: any) {
            console.error('Resubmit profile error:', error)

            // Handle ALREADY_PENDING error specifically
            if (error?.response?.body?.error === 'ALREADY_PENDING') {
                toast.warning(
                    'Your profile is already pending verification. Please wait for admin review.'
                )
            } else {
                handleError(error, 'active', authDispatch)
            }
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        const loadProfileImage = async () => {
            if (!authState?.image) {
                setProfileImageUrl(profile_img)
                return
            }

            try {
                const fileKey = authState.image.endsWith('.webp')
                    ? `original/${authState.image}`
                    : `medium/${authState.image}`

                const signedUrl = await getImageSignedUrl(fileKey)
                setProfileImageUrl(signedUrl || profile_img)
            } catch (error) {
                console.error('Error loading profile image:', error)
                setProfileImageUrl(profile_img)
            }
        }

        loadProfileImage()
    }, [authState?.image])

    // Load document images
    useEffect(() => {
        const loadDocumentImages = async () => {
            if (!authState?.documents || !Array.isArray(authState.documents)) {
                return
            }

            const urls: { [key: string]: { front?: string, back?: string } } = {}

            for (const doc of authState.documents) {
                if (doc.images && typeof doc.images === 'object') {
                    urls[doc._id] = {}

                    if (doc.images.front) {
                        try {
                            const fileKey = doc.images.front.endsWith('.webp')
                                ? `original/${doc.images.front}`
                                : `medium/${doc.images.front}`
                            const signedUrl = await getImageSignedUrl(fileKey)
                            urls[doc._id].front = signedUrl || profile_img
                        } catch (error) {
                            console.error('Error loading front document image:', error)
                            urls[doc._id].front = profile_img
                        }
                    }

                    if (doc.images.back) {
                        try {
                            const fileKey = doc.images.back.endsWith('.webp')
                                ? `original/${doc.images.back}`
                                : `medium/${doc.images.back}`
                            const signedUrl = await getImageSignedUrl(fileKey)
                            urls[doc._id].back = signedUrl || profile_img
                        } catch (error) {
                            console.error('Error loading back document image:', error)
                            urls[doc._id].back = profile_img
                        }
                    }
                }
            }

            setDocumentUrls(urls)
        }

        loadDocumentImages()
    }, [authState?.documents])


    console.log('authState', authState)

    return (<Fragment>
        {/* breadcrum  */}
        <section className="breadcrum-box">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <h2>{language_data?.[authState.lang]?.common_profile}</h2>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/">{language_data?.[authState.lang]?.common_home}</Link></li>
                                <li className="breadcrumb-item active fw-bold">{language_data?.[authState.lang]?.common_profile}</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
        {/* page  */}
        <div className='page-spacing'>
            <section className='seller-profile'>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 mb-4">
                            {authState.is_admin_verified === 'reject' && (
                                <div className="alert alert-danger p-4 rounded-3 border-0 shadow-lg" role="alert" style={{ borderLeft: '5px solid #dc3545' }}>
                                    <div className="d-flex align-items-start">
                                        <div className="alert-icon-wrapper me-3 flex-shrink-0">
                                            <div className="alert-icon-circle bg-danger bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
                                                <i className="fa fa-times-circle text-danger" style={{ fontSize: '32px' }}></i>
                                            </div>
                                        </div>
                                        <div className="alert-content flex-grow-1">
                                            <h5 className="alert-heading fw-bold mb-2 text-danger">
                                                {language_data?.[authState.lang]?.common_account_verification_rejected || 'Account Verification Rejected'}
                                            </h5>
                                            <p className="mb-3 text-muted">
                                                {language_data?.[authState.lang]?.common_account_rejected_message || 'Your seller account has been rejected by the administrator. Please review the reason below and make necessary corrections.'}
                                            </p>

                                            {authState.rejection_reason && (
                                                <div className="rejection-reason-box bg-white rounded-3 p-3 mb-3 border-start border-4 border-danger">
                                                    <h6 className="fw-bold mb-2 text-dark">
                                                        <i className="fa fa-info-circle text-danger me-2"></i>
                                                        {language_data?.[authState.lang]?.common_rejection_reason || 'Rejection Reason:'}
                                                    </h6>
                                                    <p className="mb-0 text-dark">{authState.rejection_reason}</p>
                                                </div>
                                            )}

                                            <div className="alert-actions d-flex flex-wrap gap-2 mt-3">
                                                <button
                                                    className="btn btn-danger px-4 py-2 fw-semibold"
                                                    onClick={() => navigate('/profile/edit')}
                                                >
                                                    <i className="fa fa-edit me-2"></i>
                                                    {language_data?.[authState.lang]?.common_edit_resubmit_profile || 'Edit & Resubmit Profile'}
                                                </button>
                                                <button
                                                    className="btn btn-outline-danger px-4 py-2 fw-semibold"
                                                    onClick={handleResubmitProfile}
                                                >
                                                    <i className="fa fa-refresh me-2"></i>
                                                    {language_data?.[authState.lang]?.common_resubmit_without_changes || 'Resubmit Without Changes'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {authState.is_admin_verified === 'pending' && (
                                <div className="alert alert-warning d-flex align-items-center p-4 rounded-3 border-0 shadow-sm" role="alert">
                                    <i className="fa fa-clock-o fa-3x me-3 text-warning"></i>
                                    <div>
                                        <h5 className="alert-heading fw-bold mb-1">Verification Pending</h5>
                                        <p className="mb-0">Your account is currently under review by our administrators. We'll notify you once your account is verified.</p>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="col-sm-9 col-md-5 col-lg-4 col-xl-4 col-xxl-3 px-0">
                            {/* Title  */}
                            <div className="common-card h-100">
                                <div className="common-card-title">
                                    <h5>{language_data?.[authState.lang]?.common_my}{language_data?.[authState.lang]?.common_profile}</h5>
                                </div>
                                {/* Profile  */}
                                <div className="common-card-content">
                                    {/* Profile image  */}
                                    <div className="profile-image">
                                        <img src={profileImageUrl} alt={authState.image || 'Profile'} className='' />

                                    </div>
                                    {/* Profile Detail  */}
                                    <div className="profile-image my-4">
                                        <h5 className='mb-3'>{authState.name}</h5>
                                        <p className="d-flex align-items-center mb-1"><i className='fa fa-envelope me-2 fs-5'></i>{authState.email} &nbsp;{authState.email_verified ? <i className="fa fa-check text-success" aria-hidden="true"></i> : <i className="fa fa-exclamation-triangle text-danger" aria-hidden="true" onClick={OpenEmailVerification}></i>}</p>
                                        <p className="d-flex align-items-center mt-2"><i className='fa fa-phone-square me-2  fs-5'></i>+{authState.country_code} {authState.phone_number} </p>
                                        <p className="d-flex align-items-start mt-2">{authState.full_address ? <i className='fa fa-map-marker me-2  fs-5'></i> : ''}{authState.full_address} </p></div>

                                    {authState.commission && (
                                        <p className="d-flex align-items-start mb-2"><i className='fa fa-percent me-2 fs-5'></i>{language_data?.[authState.lang]?.common_commission} {authState.commission}%</p>
                                    )}
                                    {/* button  */}
                                    <div className="profile-button">
                                        <Link to="/profile/edit" className='btn btn-theme w-100'>{language_data?.[authState.lang]?.common_edit} {language_data?.[authState.lang]?.common_profile}</Link>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* Documents section */}
                        {authState?.documents && Array.isArray(authState.documents) && authState.documents.length > 0 && (
                            <div className="col-12 px-0 mt-4">
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <h5>{language_data?.[authState.lang]?.common_documents || 'Documents'}</h5>
                                    </div>
                                    <div className="common-card-content">
                                        <div className="row">
                                            {authState.documents.map((doc: any) => (
                                                <div className="col-md-6 col-lg-4 mb-4" key={doc._id}>
                                                    <h6 className="text-capitalize fw-bold mb-3">
                                                        {/* <i className="fa fa-file-text-o me-2 text-theme"></i> */}
                                                        {doc.type.replaceAll(/_/g, ' ')}
                                                    </h6>
                                                    <div className="row g-2">
                                                        {doc.images && typeof doc.images === 'object' && (
                                                            <>
                                                                {/* Front Image */}
                                                                {doc.images.front && (
                                                                    <div className="col-6">
                                                                        <div className="document-image-wrapper border rounded overflow-hidden" style={{ height: '150px' }}>

                                                                            <img
                                                                                src={documentUrls[doc._id]?.front || profile_img}
                                                                                alt={`${doc.type} front`}
                                                                                className="w-100 h-100"
                                                                                style={{ objectFit: 'cover', cursor: 'pointer' }}
                                                                                onClick={() => window.open(documentUrls[doc._id]?.front, '_blank')}
                                                                            />
                                                                            <small className="text-muted d-block text-center mt-1">Front</small>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {/* Back Image */}
                                                                {doc.images.back && (
                                                                    <div className="col-6">
                                                                        <div className="document-image-wrapper border rounded overflow-hidden" style={{ height: '150px' }}>
                                                                            <img
                                                                                src={documentUrls[doc._id]?.back || profile_img}
                                                                                alt={`${doc.type} back`}
                                                                                className="w-100 h-100"
                                                                                style={{ objectFit: 'cover', cursor: 'pointer' }}
                                                                                onClick={() => window.open(documentUrls[doc._id]?.back, '_blank')}
                                                                            />
                                                                            <small className="text-muted d-block text-center mt-1">Back</small>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {openEmailVerification &&
                            <VerifyOtp verifyCallback={initialiseProfile} resendOtpCallback={resendEmailOtp} onCloseModal={setOpenEmailVerification} />
                        }
                    </div>
                </div>
            </section>
        </div>
    </Fragment>
    )
}

export default Profile;
